<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    stroke="currentColor"
    fill="currentColor"
  >
    <g>
      <path
        d="M110.6,375.4c-1.8,0.2-3.2,1.8-3,3.6c0.2,1.8,1.8,3.2,3.6,3h228.5c1.8,0,3.3-1.4,3.4-3.3
		c0-1.8-1.4-3.3-3.3-3.4c0,0-0.1,0-0.1,0H111.2C111,375.4,110.8,375.4,110.6,375.4 M160.6,309.6c-1.8,0.1-3.2,1.6-3.2,3.5
		c0.1,1.8,1.6,3.2,3.5,3.2h23.4c1.8,0,3.3-1.4,3.4-3.3c0-1.8-1.4-3.3-3.3-3.4h-0.1h-23.4C160.8,309.6,160.7,309.6,160.6,309.6
		 M264.5,176.4c-1.8,0.3-3.1,1.9-2.8,3.8c0.1,0.4,0.2,0.7,0.3,1c12,25,26.1,39.9,47.8,61.1c-0.3,3.7-1.5,5.6-3.2,6.6
		c-1.9,1.1-5.1,1.4-8.8,0.5c-7.4-1.7-16.1-8-18.3-12.5c-0.8-1.7-2.7-2.4-4.4-1.6c-1.2,0.6-1.9,1.7-1.9,3v11.9c0,0.5,0.1,0.9,0.3,1.3
		l8.8,20.5l7,71.2c-3,1.1-6.1,1.6-8.8,0.9c-3.2-0.8-5.8-2.8-7.3-7c0,0,0-0.1,0-0.1l-3.7-35.5c-0.6-5.7-2.7-14-4.9-19.2
		c0,0,0-0.1,0-0.1l-8.1-19.7c-0.7-1.7-2.7-2.5-4.3-1.8c-0.9,0.4-1.6,1.1-1.9,2.1l-10.6,33l-25.9,48.4c-4.1-1.1-6.9-3.4-8.5-6.5
		c-1.8-3.7-2-8.2-0.7-11.5l27.2-71c0.1-0.4,0.2-0.8,0.2-1.1l0.9-31.6c0-1.8-1.5-3.3-3.4-3.3c-1.2,0-2.3,0.7-2.8,1.7l-14.4,28.6
		c-0.8,1.5-2.4,2.5-3.5,2.4c-1.5-0.2-2.3-0.7-3.1-1.7c-0.8-1-1.5-2.4-1.9-4.2c-0.7-3.6-0.1-8.4,1.6-12l24.1-52.5
		c0.8-1.6,0.2-3.6-1.5-4.4c-1.6-0.8-3.6-0.2-4.4,1.5c0,0.1-0.1,0.1-0.1,0.2l-24.1,52.6c-2.3,4.9-3.1,10.8-2.1,16
		c0.5,2.6,1.6,5.1,3.3,7.1c1.8,2.1,4.3,3.6,7.4,4c4.7,0.6,8.4-2.5,10.2-6.1l7.7-15.1l-0.5,16l-27,70.5c-2,5.2-1.7,11.5,1,16.9
		c2.7,5.4,8.1,9.9,15.6,10.8c1.3,0.2,2.6-0.5,3.3-1.7l27.4-51.4c0.1-0.2,0.1-0.3,0.2-0.5l7.8-24.4l4.7,11.3c1.8,4.3,4,12.8,4.5,17.4
		l3.7,36.3c0,0.2,0.1,0.5,0.2,0.7c2.2,6.1,6.9,10,12,11.4c5.2,1.3,10.6,0.4,15.4-2.1c1.2-0.6,1.9-2,1.8-3.3l-2.9-29h96.2
		c1.8,0,3.3-1.4,3.4-3.3c0-1.8-1.4-3.3-3.3-3.4h-0.1h-96.9l-3.8-38.9c0-0.4-0.1-0.7-0.2-1l-8.7-20.2v-2.2c4.6,4,10.5,7.1,16.5,8.5
		c4.7,1.1,9.6,1.2,13.7-1.1c4.1-2.3,6.6-7.1,6.7-13.3c0-0.9-0.4-1.8-1-2.5c-22.5-21.9-35.7-35.8-47.6-60.5
		C267.4,176.9,266,176.2,264.5,176.4 M251.1,123.7c11.9,0,21.5,9.5,21.5,21.4s-9.6,21.5-21.5,21.5c-11.9,0-21.5-9.6-21.5-21.5
		C229.6,133.3,239.3,123.7,251.1,123.7 M251.1,117.1c-15.5,0-28.2,12.6-28.2,28c0,15.5,12.7,28.1,28.2,28.1
		c15.5,0,28.2-12.7,28.2-28.1S266.6,117.1,251.1,117.1"
      />
    </g>
  </svg>
</template>
